import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { DocumentViewerModal } from "@/shared/components/DocumentViewerModal";

export const PreviewerAttachment = () => {
	const {
		state: { rowSelectedInAttachment, displayViewerAttachment },
		actions: { setDisplayViewerAttachment },
	} = useTemplatesContext();

	const handleClose = () => {
		setDisplayViewerAttachment(false);
	};

	// Get file extension from filename
	const getExtension = (fileName?: string): string => {
		if (!fileName) return "";
		const parts = fileName.split(".");
		return parts.length > 1 ? parts[parts.length - 1] : "";
	};

	return (
		<DocumentViewerModal
			open={displayViewerAttachment}
			onClose={handleClose}
			title={rowSelectedInAttachment?.FileName || "Attachment"}
			documentPath={rowSelectedInAttachment?.Path}
			extension={getExtension(rowSelectedInAttachment?.FileName)}
		/>
	);
};
